import {createSlice} from '@reduxjs/toolkit';

const breakdownFormSlice = createSlice({
  name: 'breakdownForm',
  initialState: {
    vehicles: [],
    implements: [],
    // Display step transitions (mirrors inspectionFormSlice)
    breakdownSelectedVehicle: {},
    breakdownSelectedImplement: {},
    breakdownFormSubmitted: false,
    description: '',
    safeToOperate: null,
    operatorName: '',
    inspectedByOperator: '',
    databaseUsers: [],
    databaseUsersLoading: false,
  },
  reducers: {
    updateVehicles(state, action) {
      state.vehicles = action.payload;
    },
    updateImplements(state, action) {
      state.implements = action.payload;
    },
    setBreakdownSelectedVehicle(state, action) {
      state.breakdownSelectedVehicle = action.payload;
    },
    setBreakdownSelectedImplement(state, action) {
      state.breakdownSelectedImplement = action.payload;
    },
    setBreakdownFormSubmitted(state, action) {
      state.breakdownFormSubmitted = action.payload;
    },
    setBreakdownDescription(state, action) {
      state.description = action.payload;
    },
    setBreakdownSafeToOperate(state, action) {
      state.safeToOperate = action.payload;
    },
    setBreakdownOperatorName(state, action) {
      state.operatorName = action.payload;
    },
    setBreakdownInspectedByOperator(state, action) {
      state.inspectedByOperator = action.payload;
    },
    resetBreakdownOperatorFields(state) {
      state.operatorName = '';
      state.inspectedByOperator = '';
    },
    setDatabaseUsers(state, action) {
      state.databaseUsers = action.payload;
    },
    setDatabaseUsersLoading(state, action) {
      state.databaseUsersLoading = action.payload;
    },
    resetBreakdownFormFields(state) {
      state.description = '';
      state.safeToOperate = null;
      state.operatorName = '';
      state.inspectedByOperator = '';
    },
    resetBreakdownForm(state) {
      state.breakdownSelectedVehicle = {};
      state.breakdownSelectedImplement = {};
      state.breakdownFormSubmitted = false;
      state.description = '';
      state.safeToOperate = null;
      state.operatorName = '';
      state.inspectedByOperator = '';
    },
  },
});

export const {
  updateVehicles,
  updateImplements,
  setBreakdownSelectedVehicle,
  setBreakdownSelectedImplement,
  setBreakdownFormSubmitted,
  setBreakdownDescription,
  setBreakdownSafeToOperate,
  setBreakdownOperatorName,
  setBreakdownInspectedByOperator,
  resetBreakdownOperatorFields,
  setDatabaseUsers,
  setDatabaseUsersLoading,
  resetBreakdownFormFields,
  resetBreakdownForm,
} = breakdownFormSlice.actions;

function loadBreakdownOperators() {
  return async (dispatch) => {
    dispatch(breakdownFormSlice.actions.setDatabaseUsersLoading(true));
    try {
      const response = await fetch('/settings/getOperators', {cache: 'no-store'});
      const payload = await response.json();
      const operators = Array.isArray(payload?.operators)
        ? payload.operators
            .filter((operator) => {
              return !operator.archived;
            })
            .map((operator) => {
              return {
                uid: operator.uid,
                name: operator.name || '',
              };
            })
            .sort((a, b) => {
              return String(a.name).localeCompare(String(b.name));
            })
        : [];
      dispatch(breakdownFormSlice.actions.setDatabaseUsers(operators));
    } catch {
      dispatch(breakdownFormSlice.actions.setDatabaseUsers([]));
    } finally {
      dispatch(breakdownFormSlice.actions.setDatabaseUsersLoading(false));
    }
  };
}

export {loadBreakdownOperators};
export default breakdownFormSlice.reducer;
